// Custom Js
import { initBlogSliders } from "./blog-sliders";

let anchorScrollAbort = null;

const isVisualEditorMode = () =>
  Boolean(window.veInfo) ||
  new URLSearchParams(window.location.search).has("editMode");

const removeEmptySectionAnchors = () => {
  document.querySelectorAll("a").forEach((anchor) => {
    if (
      anchor.hasAttribute("id") &&
      anchor.attributes.length === 1 &&
      anchor.textContent?.trim() === ""
    ) {
      anchor.remove();
    }
  });
};

export const initCustomPageScripts = () => {
  if (isVisualEditorMode()) {
    return;
  }

  removeEmptySectionAnchors();
  document.querySelectorAll("text").forEach((element) => element.remove());

  initBlogSliders();

  document.querySelector(".download-file")?.setAttribute("download", "download");

  document
    .querySelectorAll('footer a[href^="tel:"], footer a[href^="mailto:"]')
    .forEach((link) => {
      link.setAttribute("rel", "noopener noreferrer nofollow");
    });

  if (anchorScrollAbort) {
    anchorScrollAbort.abort();
  }
  anchorScrollAbort = new AbortController();
  const { signal } = anchorScrollAbort;

  document
    .querySelectorAll(
      'a[href^="#"]:not([data-bs-toggle="collapse"]):not(.table-of-content a)'
    )
    .forEach((link) => {
      if (link.closest(".table-of-content")) {
        return;
      }
      link.addEventListener(
        "click",
        (e) => {
          const href = link.getAttribute("href");
          if (!href || href === "#") {
            return;
          }
          e.preventDefault();
          const targetId = href.substring(1);
          const targetSection = document.getElementById(targetId);
          if (targetSection) {
            window.scrollTo({
              top: targetSection.offsetTop - 10,
              behavior: "smooth",
            });
          }
        },
        { signal }
      );
    });

  if (
    window.location.href.includes("typo3-ki") ||
    window.location.href.includes("typo3-ai")
  ) {
    const firstHeaderButton = document.querySelector(
      ".page-header__actions .header-btn:first-child"
    );
    const title = firstHeaderButton?.querySelector("a")?.getAttribute("title");
    if (title === "TYPO3 KI" || title === "TYPO3 AI") {
      firstHeaderButton.classList.add("d-none");
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initCustomPageScripts();
});

// Download File
const downloadFile = document.querySelector(".download-file");
if (downloadFile) {
  downloadFile.setAttribute("download", "download");
}

// Add nofollow to footer email and phone links
const footerLinks = document.querySelectorAll(
  'footer a[href^="tel:"], footer a[href^="mailto:"]'
);
if (footerLinks) {
  footerLinks.forEach((link) => {
    link.setAttribute("rel", "noopener noreferrer nofollow");
  });
}

